/** @format */
import { post, download } from '@root/utils/httpWrap';
//商户列表
export const businessList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/merchant/pageList', params);
};
//车场商户列表
export const businessListByParkId = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/merchant/listByParkId', params);
};
//车场商户列表
export const listByOrgdepId = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/merchant/listByOrgdepId', params);
};
//创建商户
export const createBusiness = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/merchant/create', params);
};
//商户详情
export const businessDetail = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/merchant/detail', params);
};
//更新商户
export const editBusiness = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/merchant/edit', params);
};
//删除商户
export const deleteBusiness = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/merchant/delete', params);
};
//重置主商户密码
export const resetPwdBusiness = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/merchant/resetPwd', params);
};
//优惠券列表
export const couponList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/coupon/pageList', params);
};
//优惠券详情
export const couponDetail = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/coupon/detail', params);
};
/**
 * 优惠券导出
 * @param params
 */
export const couponExport = (params: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/coupon/export', params, fileName);
};
//创建优惠券
export const createCoupon = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/coupon/create', params);
};
//追加优惠券
export const appendCoupon = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/coupon/append', params);
};
//禁用优惠券
export const disableCoupon = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/coupon/disable', params);
};
//删除优惠券
export const deleteCoupon = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/coupon/delete', params);
};
//优惠券发放记录
export const sendRecordPageList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/couponRecord/sendRecordPageList', params);
};
//根据机构获取车场
export const findParkByOrgId = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseArea/findParkByOrgId', params);
};
/**
 * 优惠券发放导出
 * @param params
 */
export const sendRecordExport = (params: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/couponRecord/sendRecordExport', params, fileName);
};
//优惠券使用记录
export const useRecordPageList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/couponRecord/useRecordPageList', params);
};
/**
 * 优惠券使用导出
 * @param params
 */
export const useRecordExport = (params: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/couponRecord/useRecordExport', params, fileName);
};
//优惠券统计列表
export const statRecordPageList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/statRecord/dayStatPageList', params);
};
/**
 * 优惠券统计导出
 * @param params
 */
export const statRecordExport = (params: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/statRecord/dayStatExport', params, fileName);
};

//商家详情
export const statRecordetail = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/merchant/detail', params);
};
//商家详情列表
export const getAccountdetail = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/merchant/getAccount', params);
};

//套餐购买记录列表
export const getpageList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/merchantPackageRecord/pageList', params);
};

//余额变动流水列表
export const getpageListye = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/merchantPackageAccount/pagelist', params);
};
/**
 * 优惠券发放记录(时代)
 * @param params
 */
export const sendRecordTime = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/couponRecord/sendRecordTime', params);
};
/**
 * 优惠券发放记录（时代导出）
 * @param params
 */
export const sendRecordTimeExport = (params: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/couponRecord/sendRecordTimeExport', params, fileName);
};
/**
 * 车位池列表
 * @param params
 */
export const merchantSpacePool = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/merchantSpacePool/pageList', params);
};
/**
 * 商家管理（导出）
 * @param params
 */
export const merchantExport = (params: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/merchant/export', params, fileName);
};
/**
 * 单张优惠券最大额度编辑
 * @param params
 */
export const editMerchant = (params: any): Promise<ProjectResponse<any>> => {
  return post('bangdao/saasapi/v1/merchant/editMerchant', params);
};
